/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { useState, useEffect } from "react";
import { NavLink as NavLinkRRD, Link, useLocation } from "react-router-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
  Spinner,
  Badge
} from "reactstrap";

var ps;

import { connect, useDispatch } from "react-redux";
import { studentsLifetimePlan } from "util/DataList";
import store from "redux/store";
import { getUserData } from "redux/UserAuthentication/LoginActions";
import { fetchLtpItem } from "redux/ManageLifeTimePlan/ManageLifeTimePlanActions";
import { logoutUser } from "redux/UserAuthentication/LoginActions";
import { listenToUnreadCount } from "redux/Messages/MessagesAction";

// Constants for better maintainability
const MENU_CATEGORIES = {
  ADMIN_PATHS: ["Manage Community", "Manage Users", "Manage Question Bank"],
  COACH_PATHS: ["/coach-dashboard","/manage-coach-tutor-availability", "/manage-tutor-requests", "/manage-users", "/prep-talk"],
  OTHERS_PATHS: ["Ideas", "Report Bugs", "My Profile", "Settings"],
  LOCK_PAGES: ['MCAT Powerbook', 'Chatbot', "Experiences", "Achievements", "DAT Content Hub", "Personal Statement", "School Search", "COVID-19 Impact", "Manual Dexterity", "Biology", "General Chemistry", "Quantitive Reasoning", "Organic Chemistry", "My Application", "TPDC Events", "Pro Members", "Ultimate Advising Students", "PrepTalk"],
  HIDE_PATHS: ["Dashboard", "Plans", "Thank You Monthly", "Thank You Yearly", "Thank You Lifetime", "Community", "Open Community", "Pro Members", "Ultimate Advising Students", "Community Page", "Community Settings", "Biology", "General Chemistry", "Quantitive Reasoning", "Organic Chemistry", "Perceptual Ability", "Reading Comprehension", "Quantitative Reasoning", "Personal Statement", "My Application", "COVID-19 Impact", "Manual Dexterity", "Experiences", "Achievements", "TPDC Events", "TPDC Courses", "Timeline", "Courses", "Previous Tests", "Performance", "Search", "Create Test", "Full-Length Exams", "Exam Results", "Take Exam"],
  // Items in Admissions menu that should never be locked (always accessible)
  UNLOCKED_ADMISSION_ITEMS: ["Student Overview", "Community", "Courses", "TPDC Courses", "TPDC Events", "Timeline", "DAT Scores"]
};

const LAUNCH_CONFIG = {
  DATE: "2023-08-19T15:00:00.000Z",
  DATE_END: "2023-08-19T18:00:00.000Z"
};

const Sidebar = (props) => {

  // Helper functions for cleaner permission logic
  const isAdmin = () => {
    return typeof props.userDetails.admin !== "undefined" && 
           (props.userDetails.admin === "true" || props.userDetails.admin === true);
  };

  const isCoach = () => {
    return typeof props.userDetails.coach !== "undefined" && (props.userDetails.coach === "true" || props.userDetails.coach === true);
  };

  const isUltimateAdvising = () => {
    return ultimateAdvisingStudent === "true" || ultimateAdvisingStudent === true;
  };

  const isDatPro = () => {
    return typeof props.userDetails.datPro !== "undefined" && (props.userDetails.datPro === "true" || props.userDetails.datPro === true);
  };

  const isLaunchPeriodUser = () => {
    if (!createdAt) return false;
    const userCreatedAt = new Date(createdAt);
    const userCreatedAtSubtractedDate = new Date(userCreatedAt - 4 * 60 * 60 * 1000);
    return userCreatedAtSubtractedDate.toISOString() >= LAUNCH_CONFIG.DATE && 
           userCreatedAtSubtractedDate.toISOString() <= LAUNCH_CONFIG.DATE_END;
  };

  const shouldShowLocked = (pageName) => {
    return subscribe === "lock" && MENU_CATEGORIES.LOCK_PAGES.includes(pageName);
  };

  const shouldHidePage = (pageName, path, prop) => {
    // Hide routes marked as invisible (used by sub-routes that appear inside collapsible menus)
    if (prop?.invisible) return true;

    // Special case for Dashboard - only show to coaches and admins
    if (pageName === "Dashboard") {
      return !isCoach() && !isAdmin();
    }

    return MENU_CATEGORIES.OTHERS_PATHS.includes(pageName) ||
           MENU_CATEGORIES.HIDE_PATHS.includes(pageName) ||
           (!isCoach() && MENU_CATEGORIES.COACH_PATHS.includes(path) && path !== "/prep-talk");
  };

  const shouldLockItem = (itemName) => {
    // Never lock items that are in the UNLOCKED_ADMISSION_ITEMS list
    if (MENU_CATEGORIES.UNLOCKED_ADMISSION_ITEMS.includes(itemName)) {
      return false;
    }
    
    // For other items, apply the regular lock logic
    return !isUltimateAdvising() && !isDatPro();
  };

  const getIconClass = (prop) => {
    if (loadMenu) return "";
    
    // Special handling for DAT menu
    if (prop.name === "DAT Content Hub") {
      if (!isUltimateAdvising() && !isDatPro()) {
        return "fas fa-lock text-yellow";
      }
      return prop.icon;
    }
    
    // General lock logic
    if (shouldShowLocked(prop.name)) {
      return "fas fa-lock text-yellow";
    }
    
    return prop.icon;
  };

  const getMenuContent = (prop) => {
    return loadMenu ? 
      <div className="placeholder-glow"><span className="placeholder"></span></div> : 
      prop.name;
  };

  const location = useLocation();
  const dispatch = useDispatch();
  const [collapseOpen, setCollapseOpen] = useState();
  
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar

  /**
   * Subscription state management
   */
  const [subscribe, setSubscribe] = useState('lock');
  const [loadMenu, setLoadMenu] = useState(true);
  
  const fetchSubscriptionDetails = () => {
    const isUltimateStudent = props.userDetails.ultimateAdvisingStudent === "true" || 
                             props.userDetails.ultimateAdvisingStudent === true || 
                             studentsLifetimePlan.includes(props.userDetails.email);
    
    const isCoachUser = typeof props.userDetails.coach !== "undefined" && 
                       (props.userDetails.coach === "true" || props.userDetails.coach === true);
    
    if (isUltimateStudent || isCoachUser) {
      setSubscribe('unlock');
      return;
    }
    
    if (props.fetchDetailsSubscription?.fetchdetailssubscription?.length) {
      const subsDetails = props.fetchDetailsSubscription.fetchdetailssubscription[0];
      
      if (subsDetails.status === "active") {
        setSubscribe('unlock');
      } else {
        const currentTime = Math.floor(Date.now() / 1000);
        
        if (subsDetails.cancel_at_period_end) {
          setSubscribe(currentTime > subsDetails.canceled_at ? 'lock' : 'unlock');
        } else {
          setSubscribe('lock');
        }
      }
    } else {
      setSubscribe('lock');
    }
  };

  useEffect(() => {

    fetchSubscriptionDetails()

  }, [props.fetchDetailsSubscription, studentsLifetimePlan, props.userDetails ])

  useEffect(() => {
      dispatch(fetchLtpItem())
  }, [])
        
  useEffect(() => {
      if (props.fetchLtpItem.ltpitems.length) {
          props.fetchLtpItem.ltpitems.forEach((item)=>{
              if(props.userDetails.email == item.email){
                setSubscribe('unlock')
              }
          })  
      }

      if(typeof props.userDetails.coach != "undefined" && (props.userDetails.coach === "true" || props.userDetails.coach ===true)){
        setSubscribe('unlock')
        
      }
      
  }, [props.fetchLtpItem, props.userDetails]);


  function UnreadBadge({ meEmail }) {
		const [unread, setUnread] = useState(0);

		useEffect(() => {
			const stop = listenToUnreadCount({
			meEmail,
			onUpdate: (count) => setUnread(count),
			});

			return () => stop();
		}, [meEmail]);

		return  loadMenu ? "" : <h3 className="m-0 d-flex justify-content-center align-items-center">&nbsp;&nbsp;<Badge pill className={"bg-"+(unread ? "danger" : "gray")+" font-weight-bold text-white"}>{unread}</Badge></h3>;
	}

  // Simplified link creators
  const createAdminNavItem = (prop, key) => {
    if (prop.name === "Manage Community") {
      return (
        <NavItem key={key}>
          <NavLink
            style={{ cursor: 'pointer' }}
            onClick={() => toggleMenu('manageCommunity')}
            activeClassName="false"
          >
            <i className={loadMenu ? "" : prop.icon} />
            {getMenuContent(prop)}
          </NavLink>
          <Collapse isOpen={menuStates.manageCommunity} className="ml-5 p-0">
            {prop.items?.map((v, i) => (
              <Nav key={i}>
                <NavItem>
                  <NavLink
                    className="p-2"
                    to={v.layout + v.path}
                    tag={NavLinkRRD}
                    onClick={(e) => closeCollapse(e, v.name)}
                    activeClassName="false"
                  >
                    <i className={loadMenu ? "" : v.icon} />
                    {loadMenu ? "" : v.name}
                  </NavLink>
                </NavItem>
              </Nav>
            ))}
          </Collapse>
        </NavItem>
      );
    }

    if (prop.name === "Manage Question Bank") {
      return createQuestionBankNavItem(prop, key);
    }

    return (
      <NavItem key={key}>
        <NavLink
          to={prop.layout + prop.path}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
      </NavItem>
    );
  };

  const createCoachNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink
          to={prop.layout + prop.path}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
          {prop.name === "PrepTalk" && UnreadBadge({meEmail: props.userDetails.email})}
        </NavLink>
      </NavItem>
    );
  };

  const createDatNavItem = (prop, key) => {
    const isDatLocked = !isUltimateAdvising() && !isDatPro();
    
    return (
      <NavItem key={key}>
        <NavLink 
          style={{ cursor: 'pointer' }}
          to={location.pathname}
          tag={NavLinkRRD}
          onClick={() => toggleMenu('dat')}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
        <Collapse isOpen={menuStates.dat} className="ml-5 p-0">
          {prop.items?.map((v, i) => (
            <Nav key={i}>
              <NavItem>
                <NavLink
                  className="p-2"
                  to={v.layout + v.path}
                  tag={NavLinkRRD}
                  onClick={(e) => closeCollapse(e, v.name)}
                  activeClassName="active"
                  disabled={isDatLocked}
                >
                  <i className={isDatLocked ? "fas fa-lock text-yellow" : v.icon} />
                  {loadMenu ? "" : v.name}
                </NavLink>
              </NavItem>
            </Nav>
          ))}
        </Collapse>
      </NavItem>
    );
  };

  const createAdmissionsNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink 
          style={{ cursor: 'pointer' }}
          to={location.pathname}
          tag={NavLinkRRD}
          onClick={() => toggleMenu('admissions')}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
        <Collapse isOpen={menuStates.admissions} className="ml-5 p-0">
          {prop.items?.map((v, i) => {
            const isItemLocked = shouldLockItem(v.name);
            return (
              <Nav key={i}>
                <NavItem>
                  <NavLink
                    className="p-2"
                    to={v.layout + v.path}
                    tag={NavLinkRRD}
                    onClick={(e) => closeCollapse(e, v.name)}
                    activeClassName="active"
                    disabled={isItemLocked}
                  >
                    <i className={isItemLocked ? "fas fa-lock text-yellow" : v.icon} />
                    {loadMenu ? "" : v.name}
                  </NavLink>
                </NavItem>
              </Nav>
            );
          })}
        </Collapse>
      </NavItem>
    );
  };

  // const createHomeNavItem = (prop, key) => {
  //   return (
  //     <NavItem key={key}>
  //       <NavLink 
  //         style={{ cursor: 'pointer' }}
  //         to={location.pathname}
  //         tag={NavLinkRRD}
  //         onClick={() => toggleMenu('home')}
  //         activeClassName="active"
  //       >
  //         <i className={getIconClass(prop)} />
  //         {getMenuContent(prop)}
  //       </NavLink>
  //       <Collapse isOpen={menuStates.home} className="ml-5 p-0">
  //         {prop.items?.map((v, i) => {
  //           const isItemLocked = shouldLockItem(v.name);
  //           return (
  //             <Nav key={i}>
  //               <NavItem>
  //                 <NavLink
  //                   className="p-2"
  //                   to={v.layout + v.path}
  //                   tag={NavLinkRRD}
  //                   onClick={(e) => closeCollapse(e, v.name)}
  //                   activeClassName="active"
  //                   disabled={isItemLocked}
  //                 >
  //                   <i className={isItemLocked ? "fas fa-lock text-yellow" : v.icon} />
  //                   {loadMenu ? "" : v.name}
  //                 </NavLink>
  //               </NavItem>
  //             </Nav>
  //           );
  //         })}
  //       </Collapse>
  //     </NavItem>
  //   );
  // };

  const createResourcesdNavItem = (prop, key) => {
    const isDatLocked = !isUltimateAdvising() && !isDatPro();
    return (
      <NavItem key={key}>
        <NavLink 
          style={{ cursor: 'pointer' }}
          to={location.pathname}
          tag={NavLinkRRD}
          onClick={() => toggleMenu('resources')}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
        <Collapse isOpen={menuStates.resources} className="ml-5 p-0">
          {prop.items?.map((v, i) => {
            const isItemLocked = shouldLockItem(v.name);
            return (
              <Nav key={i}>
                <NavItem>
                  <NavLink
                    className="p-2"
                    to={v.layout + v.path}
                    tag={NavLinkRRD}
                    onClick={(e) => closeCollapse(e, v.name)}
                    activeClassName="active"
                    disabled={isItemLocked}
                  >
                    <i className={isItemLocked ? "fas fa-lock text-yellow" : v.icon} />
                    {loadMenu ? "" : v.name}
                  </NavLink>
                </NavItem>
              </Nav>
            );
          })}
        </Collapse>
      </NavItem>
    );
  
  }

  const createQuestionBankNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink
          style={{ cursor: 'pointer' }}
          to={location.pathname}
          tag={NavLinkRRD}
          onClick={() => toggleMenu('questionBank')}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
        <Collapse isOpen={menuStates.questionBank} className="ml-5 p-0">
          {prop.items?.map((v, i) => (
            <Nav key={i}>
              <NavItem>
                <NavLink
                  className="p-2"
                  to={v.layout + v.path}
                  tag={NavLinkRRD}
                  onClick={(e) => closeCollapse(e, v.name)}
                  activeClassName="active"
                >
                  <i className={loadMenu ? "" : v.icon} />
                  {loadMenu ? "" : v.name}
                </NavLink>
              </NavItem>
            </Nav>
          ))}
        </Collapse>
      </NavItem>
    );
  };

  const createCommunityNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink 
          style={{ cursor: 'pointer' }}
          to={prop.layout + "/community-free-members"}
          tag={NavLinkRRD}
          onClick={() => toggleMenu('community')}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
        </NavLink>
        <Collapse isOpen={menuStates.community} className="ml-5 p-0">
          {prop.items?.map((v, i) => {
            const isUasLocked = !isUltimateAdvising() && v.name === "Ultimate Advising Students";
            return (
              <Nav key={i}>
                <NavItem>
                  <NavLink
                    className="p-2"
                    to={v.layout + v.path}
                    tag={NavLinkRRD}
                    onClick={(e) => closeCollapse(e, v.name)}
                    activeClassName="active"
                    disabled={isUasLocked}
                  >
                    <i className={isUasLocked ? "fas fa-lock text-yellow" : getIconClass(v)} />
                    {loadMenu ? "" : v.name}
                  </NavLink>
                </NavItem>
              </Nav>
            );
          })}
        </Collapse>
      </NavItem>
    );
  };

  const createScheduleTutorNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink
          to={prop.layout + prop.path}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        >
          <i className={getIconClass(prop)} />
          {loadMenu ? 
            <div className="placeholder-glow mr-5"><span className="placeholder"></span></div> : 
            prop.name
          }
        </NavLink>
      </NavItem>
    );
  };

  const createStandardNavItem = (prop, key) => {
    return (
      <NavItem key={key}>
        <NavLink
          to={prop.layout + prop.path}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        > 
          <i className={getIconClass(prop)} />
          {getMenuContent(prop)}
          {prop.name === "PrepTalk" && UnreadBadge({meEmail: props.userDetails.email})}
        </NavLink>
      </NavItem>
    );
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      // Render section headings
      if (prop.type === "heading") {
        return (
          <h6 key={key} className="navbar-heading text-muted mt-3 mb-1 ml-3">
            {prop.name}
          </h6>
        );
      }

      // Render dividers
      if (prop.type === "divider") {
        return (
          <li key={key} className="my-2 mx-3" style={{ listStyle: "none" }}>
            <hr style={{ borderTop: "1px solid rgba(255, 255, 255, 0.3)", margin: "0 auto", width: "90%" }} />
          </li>
        );
      }

      // For coach users, only show dashboard, coach paths, and admin paths (if also admin)
      if (isCoach()) {
        // Always hide invisible sub-routes (e.g. QB Dashboard sub-route)
        if (prop?.invisible) return null;
        // If user is also admin, show admin menu items
        if (isAdmin() && MENU_CATEGORIES.ADMIN_PATHS.includes(prop.name)) {
          return createAdminNavItem(prop, key);
        }
        if (MENU_CATEGORIES.COACH_PATHS.includes(prop.path)) {
          return createCoachNavItem(prop, key);
        } else if (prop.name === "Dashboard") {
          // Show Dashboard for coaches
          return createStandardNavItem(prop, key);
        } else {
          // Hide all other menu items for coaches
          return null;
        }
      }
      
      // Early returns for special cases (non-coach users)
      if (prop.name === "Home") {
        return createStandardNavItem(prop, key);
      }
      
      // Admin menu handling
      if (isAdmin() && MENU_CATEGORIES.ADMIN_PATHS.includes(prop.name)) {
        return createAdminNavItem(prop, key);
      }
      
      // Skip hidden paths and coach-only paths for non-coaches
      if (shouldHidePage(prop.name, prop.path, prop)) {
        return null;
      }
      
      // Special menu items
      switch (prop.name) {
        // case "Home":
        //   return createHomeNavItem(prop, key);
        case "DAT Content Hub":
          return createDatNavItem(prop, key);
          
        case "Community":
          return createCommunityNavItem(prop, key);
          
        case "Schedule Tutor":
          return createScheduleTutorNavItem(prop, key);
        
        case "Admissions":
          return createAdmissionsNavItem(prop, key);
        
        case "Resources":
          return createResourcesdNavItem(prop, key);

        case "DAT Question Bank":
        case "Manage Question Bank":
          return createQuestionBankNavItem(prop, key);

        default:
          // Handle launch period exclusions
          let lockPages = [...MENU_CATEGORIES.LOCK_PAGES];
          if (isLaunchPeriodUser()) {
            lockPages.pop(); // Remove last item during launch period
          }
          
          return createStandardNavItem(prop, key);
      }
    }).filter(Boolean); // Remove null entries
  };

  const createOthersLinks = (routes) => {
    return routes
      .filter(prop => MENU_CATEGORIES.OTHERS_PATHS.includes(prop.name))
      .map((prop, key) => (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            activeClassName="active"
          >
            <i className={getIconClass(prop)} />
            {loadMenu ? "" : prop.name}
          </NavLink>
        </NavItem>
      ));
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  
  // Role-based logo link logic similar to AuthRoute
  const getLogoRedirectPath = () => {
    if (isAdmin()) {
      return "/admin/dashboard";
    } else if (isCoach()) {
      return "/client/coach-dashboard"; 
    } else {
      return "/client/home";
    }
  };
  
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: getLogoRedirectPath(), // Use role-based redirect instead of fixed innerLink
      tag: Link
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank"
    };
  }

  
  const [isOpen, setIsOpen] = useState(false);
  
  // Separate state for each collapsible menu
  const [menuStates, setMenuStates] = useState({
    manageCommunity: false,
    dat: false,
    community: false,
    admissions: false,
    resources: false,
    questionBank: false,
    home: true
  });

  const toggleMenu = (menuName) => {
    setMenuStates(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  // Legacy toggleMenu for backward compatibility
  const toggleMenuLegacy = () => setIsOpen(!isOpen);

  /**
   * Profile state management
   */
  const [profileState, setProfileState] = useState({
    name: '',
    createdAt: new Date(),
    ultimateAdvisingStudent: false,
    profilePictureFilename: ''
  });

  // Destructure for easier access
  const { name, createdAt, ultimateAdvisingStudent, profilePictureFilename } = profileState;

  const handleBackToAdmin = () => {
    store.dispatch(getUserData({onLogin:true}))
  };

  // Update profile state when userDetails change
  useEffect(() => {
    if (props.userDetails?.name) {
      setProfileState({
        name: props.userDetails.name,
        createdAt: props.userDetails.createdAt,
        ultimateAdvisingStudent: props.userDetails.ultimateAdvisingStudent,
        profilePictureFilename: props.userDetails.profilePicture || ''
      });
      setLoadMenu(false);
    }
  }, [props.userDetails]);

  // Handle profile picture updates
  useEffect(() => {
    if (props.createProfilePicture?.profilepicture?.length) {
      setProfileState(prev => ({
        ...prev,
        profilePictureFilename: props.createProfilePicture.profilepicture[0].profilePicture
      }));
    }
  }, [props.createProfilePicture]);

  // Collapse admissions menu when navigating to dashboard
  useEffect(() => {
    if (location.pathname === '/client/dashboard') {
      setMenuStates(prev => ({
        ...prev,
        admissions: true
      }));
    }
    
    // Collapse resources menu when navigating to community
    if (location.pathname === '/client/community') {
      setMenuStates(prev => ({
        ...prev,
        resources: true
      }));
    }

    // Expand Question Bank menu when navigating to a QB page
    if (location.pathname.includes('/question-bank')) {
      setMenuStates(prev => ({
        ...prev,
        questionBank: true
      }));
    }
  }, [location.pathname]);

  const logoutSubmit = (e) =>{
    e.preventDefault();
    localStorage.setItem('totalTime', 0);
    dispatch(logoutUser());
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-dark bg-default"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          {/* <UncontrolledDropdown nav>
            <DropdownToggle nav className="nav-link-icon">
              <i className="ni ni-bell-55" />
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="navbar-default_dropdown_1"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem>Action</DropdownItem>
              <DropdownItem>Another action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Something else here</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown> */}
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                {profilePictureFilename ? 
                
                <div className="card-profile-div-sm">
                    <div className="card-profile-image">
                      
                        <div className="profile-picture-sm" style={{backgroundImage: `url(https://storage.googleapis.com/pre-dental-tracker.appspot.com/profile-picture/` + profilePictureFilename+`)`}}></div>
                      
                    </div>
                  </div>
                  
                   :

                <div className="card-profile-image ">
                  {/* <a href="#pablo" onClick={(e) => e.preventDefault()}> */}
                    
                    <div className="rounded-circle profile-letter-sm-primary ">{name.trim()[0]}</div>
                  {/* </a> */}
                </div>}
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              {/* <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Settings</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-calendar-grid-58" />
                <span>Activity</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-support-16" />
                <span>Support</span>
              </DropdownItem> */}
              <DropdownItem divider />
              <DropdownItem href="#pablo" onClick={(e) => logoutSubmit(e)}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar  isOpen={collapseOpen} className="d-lg-flex ">
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none ">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrcWhite} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrcWhite} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          {/* <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form> */}
          {/* Navigation */}
          
          {props.adminUser.admin ?<>
          {
            props.userDetails.admin ? "" :
            <>
              <Nav navbar className="">
                <NavItem>
                  <NavLink
                    to={""}
                    onClick={e => handleBackToAdmin(e)}
                    style={{cursor:"pointer"}}>
                      <i className="fas fa-user-cog text-info"></i>
                      Back to Admin
                  </NavLink>
                </NavItem>
              </Nav>

              <hr className="my-3 border-light" />
            </>
          }
          </> :  ""}

          <Nav navbar className="">{ createLinks(routes) }</Nav>
          {/* Divider */}
          <hr className="my-3" />
          {/* Heading */}
          {/* <h6 className="navbar-heading text-muted">Others</h6> */}
          {/* Navigation */}
          <Nav className="mb-md-3 mt-auto" navbar>
            {/* <NavItem>
              <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/overview?ref=adr-admin-sidebar">
                <i className="ni ni-spaceship" />
                Manage Users
              </NavLink>
            </NavItem> */}

            {createOthersLinks(routes)}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};


const mapStateToProps = state  => {
  return {
    userDetails : state.loginAuth.userDetails,
    createProfilePicture : state.createProfilePicture,
    fetchDetailsSubscription : state.fetchDetailsSubscription,
    adminUser : state.adminUser,
    fetchLtpItem: state.fetchLtpItem,
  }
    
}


export default connect(mapStateToProps)(Sidebar);
